import { IconButton, Tooltip } from "@mui/material";
import { Star, StarBorder } from "@mui/icons-material";
import { NEON } from "../overview/boardStyles";

type Props = {
  on: boolean;
  showName: string;
  onToggle: () => void;
  size?: number;
};

/** Star that highlights a show (max 5 per person, saved by the API). Never opens the show. */
export default function HighlightStar({ on, showName, onToggle, size = 20 }: Props) {
  return (
    <Tooltip title={on ? "Remove highlight" : "Highlight this show"} arrow>
      <IconButton
        aria-pressed={on}
        aria-label={on ? `Remove highlight from ${showName}` : `Highlight ${showName}`}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onToggle();
        }}
        onMouseDown={(e) => e.stopPropagation()}
        sx={{
          p: "3px",
          flexShrink: 0,
          color: on ? NEON.color : "rgba(255,255,255,0.55)",
          filter: on ? `drop-shadow(0 0 4px ${NEON.color})` : "none",
          "&:hover": { color: NEON.color },
        }}
      >
        {on ? <Star sx={{ fontSize: size }} /> : <StarBorder sx={{ fontSize: size }} />}
      </IconButton>
    </Tooltip>
  );
}
